import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BrandMark, Etiqueta, Folio } from '../brand'
import { VendorMark } from '../brand/VendorMark'
import { SUITE_ROUTES } from '../brand/templates/routes'
import { trackMenuClick } from '../utils/analytics'

/**
 * Rodapé (cap. 09/10): a única chapa de tinta permanente do documento (D23) — régua terminada em losango acima,
 * assinatura + bio fixa, três colunas em etiqueta mono (Autonomy Suite · Empresa · Legal), fólio com copyright.
 * Sem newsletter: não havia backend por trás do formulário — um campo que não envia é promessa vazia.
 */
const COLS = [
  { key: 'suite', links: SUITE_ROUTES.map((r) => [r.to, `header.${r.slug}`] as const) },
  { key: 'company', links: [['/about', 'footer.aboutUs'], ['/brand', 'header.zeta'], ['/contacts', 'footer.contact']] as const },
  { key: 'legal', links: [['/privacy', 'footer.privacyPolicy'], ['/terms', 'footer.termsOfService']] as const },
]

export default function Footer() {
  const { t } = useTranslation()
  const year = new Date().getFullYear()
  return (
    <footer className="z-footer" data-surface="dark">
      <span className="z-regua-rodape" aria-hidden="true" />
      <div className="z-footer__grid">
        <div className="z-footer__marca">
          <BrandMark on="tinta" width={120} />
          <p className="z-footer__bio">{t('brand.bio')}</p>
          <p className="z-footer__tagline">{t('brand.tagline')}</p>
        </div>
        {COLS.map((c) => (
          <div key={c.key} className="z-footer__col">
            <Etiqueta as="p">{t(`footer.${c.key}`)}</Etiqueta>
            <ul className="z-footer__lista">
              {c.links.map(([to, k]) => (
                <li key={to}><Link to={to} className="z-footer__link" onClick={() => trackMenuClick(to, 'footer')}>{t(k)}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="z-footer__base">
        <Folio as="p">© {year} Zentriz · {t('footer.madeWithLove')}</Folio>
        <p className="z-footer__canais">
          <a className="z-footer__link" href="mailto:contato@zentriz.com.br">contato@zentriz.com.br</a>
          <a className="z-footer__link" href="tel:+5511915629996">+55 (11) 91562-9996</a>
          <a className="z-footer__link z-footer__vendor" href="https://wa.me/5511915629996" rel="noopener noreferrer" target="_blank" aria-label="WhatsApp"><VendorMark vendor="whatsapp" size={18} /></a>
        </p>
      </div>
    </footer>
  )
}
